import { axios, baseURL } from "./axios.dashboard"

const getBranch = async () => {
    return await axios
        .get(baseURL+"user/getBranches")
        .then((response) => {
            return response
        }).catch((e) => {
            return e.response.data
    })
}

export { getBranch }